import type { PolicyViewModel } from 'src/api/types/PolicyViewModel';

import Grid from '@mui/material/Grid';

import { useSupportDrawerContext } from 'src/components/support-drawer/context/use-support-drawer-context';
// ----------------------------------------------------------------------

import { RatingHistory } from '../../shared/rating-history';

type PolicyRatingHistoryProps = {
  viewPolicy: PolicyViewModel;
};

export function PolicyRatingHistory({ viewPolicy }: PolicyRatingHistoryProps) {
  const drawerContext = useSupportDrawerContext();

  let headerWidth: string = '100%';
  if (drawerContext.openDrawer) {
    if (drawerContext.drawerWidth.includes('%')) {
      const numPart: string = drawerContext.drawerWidth.replace('%', '');
      const calcDrawer: number = Number.parseFloat(numPart) / 100;
      headerWidth = `calc(100% - (100vw * ${calcDrawer.toString()}))`;
    } else headerWidth = `calc(100% - ${drawerContext.drawerWidth})`;
  }

  const renderContent = () => (
    <Grid container spacing={2} columns={16}>
      <Grid size={{ xs: 16, md: drawerContext.openDrawer ? 16 : 12 }}>
        <RatingHistory width={headerWidth} viewPolicy={viewPolicy} />
      </Grid>
    </Grid>
  );
  return <>{renderContent()}</>;
}
